// 开票专员菜单


let menuInvoice = [
    
    // {
    //     path:'/',
    //     component: "HomeView",
    //     redirect: '/home/IndexView',
    //     name: '首页',
    //     parent:true,
    //     children:[
    //         {
    //             pageAddress:"IndexView",
    //             path:"/home/IndexView",
    //             component:"IndexView",
    //             name:"实时数据",
    //         }
    //     ]

    // },
    // {
    //     path: '/p0',
    //     component: "HomeView",
    //     name: '营销管理',
	// 	disable:true,//无权限
    // },
	// {
    //     path: '/p1',
    //     component: "HomeView",
    //     name: '运营管理',
    //     disable:true,//无权限
    // },
    // {
	// 	path:'/p2',
    //     redirect: '/common/FMcontractData',
    //     component: "HomeView",
    //     name: '合同管理',
    //     parent:true,
    //     children:[
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"合同管理",
    //             children:[
    //                 // {
    //                 //     pageAddress:"fm/FMcontractData",
    //                 //     path:"/common/FMcontractData",
    //                 //     component:"contractData",
    //                 //     name:"合同总纲",
    //                 //     meta:{
    //                 //         keepAlive:true,
    //                 //     }
    //                 // },
    //                 // {
    //                 //     pageAddress:"cm/CMProjectModifyList",
    //                 //     path:"/cm/project/CMProjectModifyList",
    //                 //     component:"CMProjectModifyList",
    //                 //     name:"变更合同"
    //                 // },
    //                 {
	// 				    pageAddress:"commonPage/dataReport/contractDataInfo",
	// 				    path:"/common/contractDataInfo",
	// 				    component:"contractDataInfo",
	// 				    hidden:true,
	// 				    name:"合同总纲详情",
	// 				},
	// 				{
	// 					pageAddress:"CommonContractReadView0",
	// 					path:"/cm/contract/read_view0",
	// 					hidden:true,
	// 					name:"合同详情"
	// 				},
                    
    //                 {
    //                     pageAddress:"CommonContractAuditView",
    //                     path:"/common/contract/CommonContractEditView",
    //                     hidden:true,
    //                     name:"审核合同"
    //                 },
    //                 {
    //                     pageAddress:"CommonContractReadView",
    //                     path:"/common/contract/CommonContractReadView",
    //                     hidden:true,
    //                     name:"合同详情"
    //                 },
                  
    //                 {
    //                     pageAddress:"CommonContractModifyCheck",
    //                     path:"/common/contractModify/CommonContractModifyCheck",
    //                     hidden:true,
    //                     name:"变更合同审核"
    //                 },
    //                 {
    //                     pageAddress:"CommonContractModifyDetail",
    //                     path:"/common/contractModify/CommonContractModifyDetail",
    //                     hidden:true,
    //                     name:"变更合同详情"
    //                 },
    //             ]
    //         }
    //     ]

    // },
    // {
    //     path: '/p3',
    //     component: "HomeView",
    //     name: '工程管理',
    //     disable:true,//无权限
    // },
    {
		path:'/p4',
        redirect: '/common/materialList',
        component: "HomeView",
        name: '材料管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"代付材料",
                children:[
                    // {
                    //     pageAddress:"commonPage/financeManage/materialList",
                    //     path:"/common/materialList",
                    //     name:"代付申请"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/materialDetail",
                        path:"/common/materialDetail",
                        hidden:true,
                        name:"代付材料申请详情"
                    },
                    {
                        pageAddress:"commonPage/financeManage/marginDetail",
                        path:"/common/marginDetail",
                        hidden:true,
                        name:"代付投标保证金申请详情"
                    },
                    {
                        pageAddress:"commonPage/financeManage/depositDetail",
                        path:"/common/depositDetail",
                        hidden:true,
                        name:"代付物业押金详情"
                    },
                    // {
                    //     pageAddress:"commonPage/financeManage/purchaseList",
                    //     path:"/common/purchaseList",
                    //     name:"材料购销合同"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/purchaseDetail",
                        path:"/common/purchaseDetail",
                        hidden:true,
                        name:"材料购销合同详情"
                    },
                    {
                        pageAddress:"commonPage/financeManage/purchaseApply",
                        path:"/common/purchaseApply",
                        hidden:true,
                        name:"新增材料购销合同"
                    },	
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"众惠材料",
                children:[
                    // {
                    //     pageAddress:"commonPage/financeManage/zhotyImportList",
                    //     path:"/common/zhotyImportList",
                    //     name:"材料导入记录"
                    // },
                ]
            }
        ]

    },
    {
		path:'/p5',
        redirect: '/fm/FMStatProjectIndexView',
        component: "HomeView",
        name: '财务管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"总表视图",
                children:[
                    // {
                    //     pageAddress:"fm/FMStatProjectIndexView",
                    //     path:"/fm/FMStatProjectIndexView",
                    //     name:"项目视图"
                    // },
                    // {
                    //     pageAddress:"commonPage/dataReport/financeData",
                    //     path:"/common/financeData",
                    //     component:"financeData",
                    //     name:"财务总表",
                    //     meta:{
                    //         keepAlive:true,
                    //     }
                    // },
                    {
                        pageAddress:"commonPage/dataReport/financeDataInfo",
                        path:"/common/financeDataInfo",
                        component:"financeDataInfo",
                        hidden:true,
                        name:"财务数据详情"
                    },
                    // {
                    //     pageAddress:"fm/FMStatPmReadView",
                    //     path:"/fm/FMStatPmReadView",
                    //     name:"总监视图"
                    // },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"资金管理",
                children:[
                    // {
                    //     pageAddress:"fm/FMFinanceIncomeIndexView",
                    //     path:"/fm/FMFinanceIncomeIndexView",
                    //     name:"收款流水"
                    // },
                    {
                        pageAddress:"fm/FMFinanceIncomeEditView",
                        path:"/fm/financeIncome/edit",
                        hidden:true,
                        name:"收款流水细节"
                    },	
                    {
                        pageAddress:"fm/FMFinanceIncomeReadView",
                        path:"/fm/financeIncome/read",
                        hidden:true,
                        name:"流水信息"
                    },
                    // { 
                    //     path: '/finance/insurance',
                    //     component:'insuranceList',
                    //     name: '保险记录',
                    //     pageAddress:"finance/insuranceList",
                    // },
                    // {
                    //     pageAddress:"commonPage/financeManage/servicePayList",
                    //     path:"/common/servicePayList",
                    //     name:"劳务支付"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/servicePayEdit",
                        path:"/common/servicePayEdit",
                        hidden:true,
                        name:"编辑劳务支付"
                    },
                    {
                        pageAddress:"commonPage/financeManage/servicePayDetail",
                        path:"/common/servicePayDetail",
                        hidden:true,
                        name:"劳务支付详情"
                    },	
                    // {
                    //     pageAddress:"fm/FMDeductionList",
                    //     path:"/fm/FMDeductionList",
                    //     name:"手动扣款", 
                    // },
                    {
                        pageAddress:"fm/FMDeductionDetail",
                        path:"/fm/FMDeductionDetail",
                        hidden:true,
                        name:"手动扣款详情", 
                    },	
                    {
                        pageAddress:"fm/FMAddDeduction",
                        path:"/fm/FMAddDeduction",
                        hidden:true,
                        name:"添加手动扣款", 
                    },				
                                        
                    {
                        pageAddress:"fm/FMStatProjectReadView",
                        path:"/fm/FMStatProjectReadView",
                        hidden:true,
                        name:"项目细节"
                    },	
                    // {
                    //     pageAddress:"commonPage/financeManage/applyPaymentList",
                    //     path:"/common/applyPaymentList",
                    //     meta: {
                    //         keepAlive: true // 需要被缓存
                    //     },
                    //     name:"用款申请"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/applyPaymentDetail",
                        path:"/common/applyPaymentDetail",
                        hidden:true,
                        name:"用款申请详情"
                    },	
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"发票管理",
                children:[
                    // {
                    //     pageAddress:"fm/FmOutPutTicket",
                    //     path:"/fm/FmOutPutTicket",
                    //     name:"销项票"
                    // },		
                    {
                        pageAddress:"fm/FmOutPutTicketDetail",
                        path:"/fm/FmOutPutTicketDetail",
                        hidden:true,
                        name:"开票详情"
                    },	
                    {
                        pageAddress:"fm/FmAddOutPutTicket",
                        path:"/fm/FmAddOutPutTicket",
                        hidden:true,
                        name:"添加开票"
                    },	
                ]
            },
        ]

    },
    // {
    //     path: '/p6',
    //     component: "HomeView",
    //     name: '项目总监管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p7',
    //     component: "HomeView",
    //     name: '客户管理',
    //     disable:true,//无权限
    // },
	{
		path:'/p8',
        redirect: '/pm/personaldata/changePassWord',
        component: "HomeView",
        name: '系统管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"个人设置",
                children:[
                    // {
                    //     pageAddress:"pm/PMChangePasswordView",
                    //     path:"/pm/personaldata/changePassWord",
                    //     component:"PMChangePasswordView",
                    //     name:"修改密码"
                    // }	
                ]
            }
        ]

    },
    {
        pageAddress:"fm/printOutPutTicket",
        path:"/common/printOutPutTicket",
        component:"printOutPutTicket",
        hidden:true,
        name:"打印销项票"
    },
    {
        pageAddress:"commonPage/dataReport/printSettleForm",
        path:"/common/printSettleForm",
        component:"printSettleForm",
        hidden:true,
        name:"打印结算表"
    },
    {
        pageAddress:"commonPage/financeManage/NewXiangmushitu",
        path:"/common/New",
        hidden:true,
        name:"项目视图新建页面导出数据"
    },
    {
        pageAddress:"commonPage/financeManage/depositPrint",
        path:"/common/depositPrint",
        hidden:true,
        name:"打印物业押金"
    },
    {
        pageAddress:"commonPage/financeManage/marginPrint",
        path:"/common/marginPrint",
        hidden:true,
        name:"打印代付投标保证金"
    },
    {
        pageAddress:"commonPage/financeManage/materialPrint",
        path:"/common/materialPrint",
        hidden:true,
        name:"打印付款申请单"
    },
    {
        pageAddress:"fm/receiptConfirmation",
        path:"/fm/financeIncome/receiptConfirmation",
        hidden:true,
        // name:"打印收款流水"
    },
    {
        pageAddress:"commonPage/financeManage/serviceFeePrint",
        path:"/common/serviceFeePrint",
        hidden:true,
        // name:"打印劳务支付"
    },	
];

export default menuInvoice;


// WEBPACK FOOTER //
// ./src/menu/menuInvoice.js